import { useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { track, EVENTS } from "../lib/analytics";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useLeadForm({ type, initial, required, onSuccessEvent }) {
  const { pathname } = useLocation();
  const [values, setValues] = useState(initial);
  const [errors, setErrors] = useState({});
  const [state, setState] = useState("idle"); // idle | submitting | success | failure
  const [started, setStarted] = useState(false);
  const [leadId, setLeadId] = useState(null);

  const set = (k, v) => {
    if (!started) { setStarted(true); track(EVENTS.FORM_START, { form: type }); }
    setValues((s) => ({ ...s, [k]: v }));
    if (errors[k]) setErrors((e) => { const n = { ...e }; delete n[k]; return n; });
  };

  const validate = () => {
    const e = {};
    required.forEach((k) => { if (!values[k] || (typeof values[k] === "string" && !values[k].trim())) e[k] = "This field is required."; });
    if (values.email && !EMAIL_RE.test(values.email)) e.email = "Enter a valid email address.";
    if (values.consent === false) e.consent = "Please accept the privacy notice to continue.";
    return e;
  };

  const submit = async (buildPayload) => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e); track(EVENTS.FORM_ERROR, { form: type, fields: Object.keys(e) });
      const first = document.querySelector(`[name="${Object.keys(e)[0]}"]`); first && first.focus();
      return;
    }
    setState("submitting");
    try {
      const payload = { type, source_page: pathname, website: values.website || "", ...buildPayload(values) };
      const res = await api.post("/leads", payload);
      setLeadId(res.data.id); setState("success");
      track(EVENTS.FORM_SUBMIT, { form: type });
      if (onSuccessEvent) track(onSuccessEvent, { form: type });
    } catch (err) {
      setState("failure");
      setErrors({ _form: err?.response?.data?.detail || "Something went wrong. Your entries are preserved — please try again." });
    }
  };

  const reset = () => { setValues(initial); setErrors({}); setState("idle"); setStarted(false); };
  return { values, set, errors, state, submit, reset, leadId };
}
